export const CONTRACT_TYPE_ALL = 'All'
export const CONTRACT_TYPE_OPEN_MARKET = 'openMarket'
export const IPS_CONTRACT_ID_COOKIE_NAME = 'ips-contract-id'
export const IPS_CONTRACT_NAME_COOKIE_NAME = 'ips-contract-name'

export const CONTRACT_ALL = {
  displayName: CONTRACT_TYPE_ALL,
  id: CONTRACT_TYPE_ALL,
  name: CONTRACT_TYPE_ALL,
  longDescription: CONTRACT_TYPE_ALL,
}

export const CONTRACT_OPEN_MARKET = {
  displayName: 'Open market',
  id: CONTRACT_TYPE_OPEN_MARKET,
  name: 'Open market',
  longDescription: CONTRACT_TYPE_OPEN_MARKET,
}
